import { render, staticRenderFns } from "./mdBackQuerySh.vue?vue&type=template&id=1885f610&scoped=true"
import script from "./mdBackQuerySh.vue?vue&type=script&lang=js"
export * from "./mdBackQuerySh.vue?vue&type=script&lang=js"
import style0 from "./mdBackQuerySh.vue?vue&type=style&index=0&id=1885f610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885f610",
  null
  
)

export default component.exports